/**
 * Token storage — mirrors GetStorage usage in Flutter (`access_token` /
 * `refresh_token`). Web uses localStorage; the in-memory cache prevents the
 * sync read on every request from hitting the storage API repeatedly.
 *
 * Note: localStorage is not as secure as iOS Keychain / Android EncryptedSharedPreferences.
 * Acceptable for a JWT short-TTL access token; refresh-token rotation on the
 * server side bounds the blast radius of an XSS theft.
 */

const ACCESS_KEY = 'access_token';
const REFRESH_KEY = 'refresh_token';

let accessCache: string | null = null;
let refreshCache: string | null = null;

export const tokenStorage = {
  getAccess(): string | null {
    if (accessCache !== null) return accessCache;
    accessCache = localStorage.getItem(ACCESS_KEY);
    return accessCache;
  },
  getRefresh(): string | null {
    if (refreshCache !== null) return refreshCache;
    refreshCache = localStorage.getItem(REFRESH_KEY);
    return refreshCache;
  },
  set(access: string, refresh: string) {
    accessCache = access;
    refreshCache = refresh;
    localStorage.setItem(ACCESS_KEY, access);
    localStorage.setItem(REFRESH_KEY, refresh);
  },
  clear() {
    accessCache = null;
    refreshCache = null;
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};
